// El admin es solo web: los tokens viven en localStorage (el dashboard de escritorio
// usa el storage cifrado de Electron, acá no aplica).
const TokenStorage = {
  getToken: (key) => localStorage.getItem(key),
  setToken: (key, value) => localStorage.setItem(key, value),
  removeToken: (key) => localStorage.removeItem(key),
};

export default TokenStorage;
